import { observable, runInAction, action, makeObservable } from 'mobx'
import SilentListStore from 'stores/SilentListStore'
import NotificationsService from 'services/NotificationsService'
import QuotesService from 'services/QuotesService'
import Paginator from 'models/Paginator'
import {
    QUOTES_LIST_DYNAMIC,
    QUOTES_LIST_CLUSTER,
} from 'routing/routes'
import {
    RISK_TYPE_CAR,
    RISK_TYPE_COMMERCE,
    RISK_TYPE_HOME,
} from 'util/riskTypes'

class NotificationsStore extends SilentListStore {
    currentPage = 1
    notifications = []
    paginator = Paginator.empty()
    notificationSearchText = ''

    constructor() {
        super({ itemsKey: 'notifications' })

        makeObservable(this, {
            // observable
            currentPage: observable,
            notifications: observable,
            paginator: observable,
            notificationSearchText: observable,
            // action
            changePage: action,
            getNotificationsList: action,
            redirectMultiquote: action,
            ...this.getSilentListAnnotations(),
        })

        this.notificationsService = new NotificationsService()
        this.quotesService = new QuotesService()
    }

    getListCacheKey() {
        return [
            this.notificationSearchText || '',
            this.currentPage,
        ].join('|')
    }

    changePage(page) {
        this.currentPage = page
    }

    async getNotificationsList({ silent = false, text } = {}) {
        if (text !== undefined) {
            this.notificationSearchText = text
        }

        await this.fetchList({
            silent,
            onRetry: () => this.getNotificationsList(),
            request: async () => {
                const params = {
                    page: this.currentPage,
                    name: this.notificationSearchText || text,
                }
                const response = await this.notificationsService.listNofitications(params)

                return {
                    items: response.notifications,
                    paginator: response.paginator,
                }
            },
        })
    }

    async redirectMultiquote(id, callback) {
        this.preRequest(this.redirectMultiquote)

        try {
            const quoteType = await this.notificationsService.getQuoteTypeById(id)

            runInAction(() => {
                switch (quoteType) {
                    case RISK_TYPE_HOME:
                        callback(QUOTES_LIST_DYNAMIC?.replace(':id', id))
                        break

                    case RISK_TYPE_COMMERCE:
                        callback(QUOTES_LIST_DYNAMIC?.replace(':id', id))
                        break

                    case RISK_TYPE_CAR:
                        callback(QUOTES_LIST_CLUSTER?.replace(':id', id))
                        break

                    default:
                }

                this.onSuccessRequest()
            })
        } catch (e) {
            runInAction(() => {
                this.onErrorRequest(e)
            })
        }
    }
}

export default NotificationsStore
